import cuiTitle from './title.vue'
import cuiPhone from './phone.vue'
import cuiPlate from './plate.vue'

export default {
    install: function (Vue) {
        Vue.component('cui-title', cuiTitle)
        Vue.component('cui-phone', cuiPhone)
        Vue.component('cui-plate', cuiPlate)
    }
}